var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"note-wrapper",class:_vm.note.priority,style:(_vm.styles),on:{"dblclick":_vm.dblCLickHandler}},[_vm._v(" "+_vm._s(_vm.note.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }